import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const ContentCopyIcon: FunctionComponent<SvgIconProps> = (props) => {
	return (
		<SvgIcon viewBox="0 0 16 16" {...props}>
			<path d="M10.6668 0.666626H2.66683C1.93016 0.666626 1.3335 1.26329 1.3335 1.99996V11.3333H2.66683V1.99996H10.6668V0.666626ZM12.6668 3.33329H5.3335C4.59683 3.33329 4.00016 3.92996 4.00016 4.66663V14C4.00016 14.7366 4.59683 15.3333 5.3335 15.3333H12.6668C13.4035 15.3333 14.0002 14.7366 14.0002 14V4.66663C14.0002 3.92996 13.4035 3.33329 12.6668 3.33329ZM12.6668 14H5.3335V4.66663H12.6668V14Z" fill="#79818F" />
		</SvgIcon>
	);
};

export default ContentCopyIcon;
